import React from 'react';
import { z } from 'zod';
import { COLOR_SCHEMA } from '../color';
import { getPadding, PADDING_SCHEMA } from '../padding';
export const DividerPropsSchema = z.object({
    style: z
        .object({
        backgroundColor: COLOR_SCHEMA,
        padding: PADDING_SCHEMA,
    })
        .optional()
        .nullable(),
    props: z
        .object({
        lineColor: COLOR_SCHEMA,
        lineHeight: z.number().optional().nullable(),
    })
        .optional()
        .nullable(),
});
export function Divider({ style, props }) {
    var _e;
    const st = {
        padding: getPadding(style === null || style === void 0 ? void 0 : style.padding),
        backgroundColor: (_e = style === null || style === void 0 ? void 0 : style.backgroundColor) !== null && _e !== void 0 ? _e : undefined,
    };
    const borderTopWidth = props === null || props === void 0 ? void 0 : props.lineHeight;
    const borderTopColor = props === null || props === void 0 ? void 0 : props.lineColor;
    return (React.createElement("div", { style: st },
        React.createElement("hr", { style: {
                width: '100%',
                border: 'none',
                borderTop: `${borderTopWidth}px solid ${borderTopColor}`,
                margin: 0,
            } })));
}
//# sourceMappingURL=Divider.js.map